import Vue                                from "vue";
import { mapGetters }                     from "vuex";
import { formatDateTime, 
         stringHelper }                   from "@/components/mixins";
import { CurrencyText }                   from "@/components";

import { ErrorLogService,
         GridUtil,
         PartDetailServices }             from "@/services";

import { IColumnConfig }                  from "@/types";

export default Vue.extend({
    name: "CrossReferenceTab",
    components: {
        CurrencyText,
    },
    mixins: [formatDateTime, stringHelper],
    computed: {
        ...mapGetters(["user", "getContentItem", "billingCurrencyCode", "activeAccountId", "canSeeOemList"]),
        columns() {
            return this.canSeeOemList
                ? this.allColumns
                : this.allColumns.filter((x: IColumnConfig) => x.key !== "CrossOemListPrice");
        },
    },

    props: {
        oemPartCode: {
            type: String,
            default: "",
        },
        partDescription: {
            type: String,
            default: "",
        },
        partId: {
            type: Number,
            default: 0,
        }
    },

    created() {
        this.allColumns = GridUtil.localizeColumnLabels(this.allColumns, this.getContentItem);
    },

    data: () => ({
        allColumns: [
            { key: "OemDescription", localizationKey: "Oem" },
            { key: "PartNumber", localizationKey: "OEMPart" },
            { key: "CrossOemListPrice", localizationKey: "OEMListPrice" }
        ],
        loadingCrossReferences: false,
        haveSuccessfullyLoadedCrossReferences: false,
        items: null,
        textFilter: null,
        crossMessageLocalizationKey: "CrossMessage1",
        crossReferences: []
    }),

    methods: {
        async getCrossReferences() {
            try {
                this.loadingCrossReferences = true;

                const params = {
                    oemPartCode: this.oemPartCode,
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    partId: this.partId
                };

                const data = await PartDetailServices.getCrossReferences(params);

                this.crossMessageLocalizationKey = data && data.length > 0 ? "CrossMessage1" : "CrossMessage2";

                this.crossReferences = data;
                this.haveSuccessfullyLoadedCrossReferences = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
                this.loadingCrossReferences = false;
            }
        },

        filterGrid(row: any) {
            return GridUtil.filterGrid(row, this.textFilter);
        },
        loadTabData(){
            if(!this.haveSuccessfullyLoadedCrossReferences && !this.loadingCrossReferences){
                this.getCrossReferences()
            }
        }
    },
});
